import { takeLatest } from "redux-saga/effects";
import { getAllCourseLevelAction } from "./slices/getAllCourseLevel";
import { getAllCourseLevelWorker } from "./worker";

const getAllCourseLevelWatcher = [
  takeLatest(getAllCourseLevelAction, getAllCourseLevelWorker),
];

export default getAllCourseLevelWatcher;
